<div class="quote-reposts-modal-container">
  <div
    class="w-100 d-flex justify-content-end border-bottom border-color-grey cursor-pointer text-grey5"
  >
    <div
      class="py-5px px-15px fs-25px font-weight-bold"
      (click)="bsModalRef.hide()"
    >
      &times;
    </div>
  </div>

  <div class="flex-grow-1">
    <div
      #uiScroll
      *uiScroll="let post of datasource"
      class="border-bottom border-color-grey"
    >
      <feed-post
        *ngIf="!post.IsHidden"
        [post]="post"
        [includePaddingOnPost]="true"
        [parentPost]="post.parentPost"
        [contentShouldLinkToThread]="true"
        [blocked]="
          globalVars.hasUserBlockedCreator(post.PosterPublicKeyBase58Check)
        "
        [containerModalRef]="bsModalRef"
      ></feed-post>
    </div>
  </div>

  <simple-center-loader *ngIf="loading"></simple-center-loader>
</div>
